import {CommonDataTableFields, GroupSortableColumnsDictionary} from '../types';

export const GroupSortableTrendColumns: GroupSortableColumnsDictionary = {
  [CommonDataTableFields.Average]: {sortSelectTitle: `Average`},
  [CommonDataTableFields.LiftAverage]: {sortSelectTitle: `Average`},
};
// If we add cohort size as a column (it is currently hidden), we could add it to GroupSortableTrendColumns and remove this constant
export const GroupSortableTrendFields = [...Object.keys(GroupSortableTrendColumns), CommonDataTableFields.CohortSize];
